import { LatLng } from "../components/UI/MarkerMap";

export const MAP = {
  DEFAULT_POS: { lat: 55.7558, lng: 37.6173 } as LatLng,
  DEFAULT_ZOOM: 7,
};
